import React from 'react'
import TextButton from './text-button'

interface IProps {
  label: string
  onClick: any
  disabled?: boolean
  fontSize?: string
}

class ReadMoreButton extends React.Component<IProps> {
  getStyle = () => {
    const { fontSize } = this.props
    let style = {
      marginLeft: '5px',
      padding: '0px 5px',
      verticalAlign: 'baseline',
      lineHeight: 1
    }
    if (fontSize) {
      return { ...style, fontSize: fontSize }
    }
    return style
  }

  render() {
    const { label, ...textButtonProps } = this.props
    return (
      <TextButton {...textButtonProps} style={this.getStyle()}>
        {label}
      </TextButton>
    )
  }
}

export default ReadMoreButton
